import type { SVGProps } from 'react';

const SvgDownloadMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M7 12L12 16L17 12' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4 20H20' stroke='currentColor' strokeWidth={1.5} strokeMiterlimit={10} strokeLinecap='round' />
    <path d='M12 4V16' stroke='currentColor' strokeWidth={1.5} strokeMiterlimit={10} strokeLinecap='round' />
  </svg>
);
export default SvgDownloadMd;
